import { Observable, tap } from 'rxjs';
import { Component, Input, OnInit } from '@angular/core';
import { UtilsService } from 'app/modules/utils-service';
import { DetalleBienCulturalService } from '../../detalle-bien-cultural.service';
import { PutDetalleBienes } from '../../info-principal-bien-cultural/models/put-detalle-bienes.model';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { DataFichaRegistro, FichaRegistro } from 'app/models/fichaRegistro.model';
import { Tipologia } from 'app/models/tipologias.model';
import { T } from '@angular/cdk/keycodes';
import { Data } from '@angular/router';

@Component({
    selector: 'descripcion-bien-cultural',
    templateUrl: 'descripcion.component.html',
    imports: [
        CommonModule,
        FormsModule,
        MatButtonModule
    ]
})

export class DescripcionComponent implements OnInit {
    detalle:PutDetalleBienes
    ficha$:Observable<DataFichaRegistro>
    
    constructor(
        private detalleBienesService: DetalleBienCulturalService,
        private utilsService: UtilsService  
    ) { }

    ngOnInit(): void {
        this.ficha$ = this.detalleBienesService.fichaRegisto$.pipe(
            tap(ficha => {
            if (ficha) {
                this.detalle = {
                descripcion: ficha.bienCultural.descripcion,
                tipoPropiedad: ficha.bienCultural.tipoPropiedad || {} as Tipologia,
                tipoPoseedor: ficha.bienCultural.tipoPoseedor || {} as Tipologia,
                anotaciones: ficha.bienCultural.anotaciones || '',
                observaciones: ficha.bienCultural.observaciones || '',
                decretoAcuerdo: ficha.bienCultural.decretoAcuerdo || ''
                } as PutDetalleBienes;
            }
            })
        );
    }

    putDetalleBienCultural(bienCulturalUuid:string){
        this.detalle.descripcion = this.detalle.descripcion?.trim() || '';
        
        this.detalleBienesService.putDetalleBienCultural(bienCulturalUuid, this.detalle)
        .then(response=>{
            this.detalleBienesService.getFichaRegistro(bienCulturalUuid)
            this.utilsService.openSuccessSnakBar('Información actualizada correctamente.')
        })
    }

}